import { FEATURES } from '../content';

export function Features() {
  return (
    <section className="section hairline-t" id="features">
      <div className="container">
        <div style={{ maxWidth: 620, marginBottom: 64 }}>
          <div className="eyebrow" style={{ marginBottom: 18 }}>
            The Studio
          </div>
          <h2 className="h-title">Everything you need to read a head.</h2>
        </div>
        <div
          className="feature-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '1px',
            background: 'var(--line-1)',
            border: '0.5px solid var(--line-1)',
          }}
        >
          {FEATURES.map((f) => (
            <div key={f.k} style={{ background: 'var(--bg-1)', padding: '36px 34px' }}>
              <div
                className="mono"
                style={{
                  fontSize: 11,
                  color: 'var(--fg-4)',
                  letterSpacing: '0.14em',
                  marginBottom: 22,
                }}
              >
                {f.k}
              </div>
              <h3
                style={{
                  fontSize: 22,
                  fontWeight: 600,
                  letterSpacing: '-0.02em',
                  margin: '0 0 10px',
                }}
              >
                {f.t}
              </h3>
              <p
                style={{
                  fontSize: 14.5,
                  lineHeight: 1.6,
                  color: 'var(--fg-2)',
                  margin: 0,
                  maxWidth: '40ch',
                }}
              >
                {f.s}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
